<script lang="ts">
	import UserPositions from '$lib/home/userHoldings/UserPositions.svelte';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
</script>

<GradientBorder
	gradient="bg-fx-gradient-6"
	paddingClass="p-px"
	borderRadius="rounded-2xl"
	outerClassList=""
	innerClassList="flex justify-center items-center bg-fx-black"
>
	<div class="bg-fx-gradient-8-40 sm:p-6 p-4 w-full rounded-2xl">
		<div class="text-fx-gradient-5 font-semibold text-xl">Positions</div>

		<div class="border-t border-t-fx-grey-600 my-2" />
		<UserPositions showClosePosition={false} />
	</div>
</GradientBorder>
